import i18n from '../i18n';
import { toMessageKey } from './translations';

const codeKey = (code) => `api.responses.${code}`;

// Resolves a backend response body to a translation descriptor.
// Precedence: coded+translated key > legacy message > screen fallback >
// generic unknown. Returns { key, params } so views can render
// t(message.key, message.params) and re-translate on language change.
//
// `code` fields are preferred when the frontend catalog knows them; unknown
// codes fall through to the legacy message path so an ahead-of-frontend
// backend never blanks out an alert. `success`, HTTP status and marker
// fields are deliberately not read here — display only.
const apiResponseMessage = (body, fallbackKey = 'api.responses.unknown') => {
    if (body && typeof body === 'object') {
        if (body.code && i18n.exists(codeKey(body.code))) {
            return { key: codeKey(body.code), params: body.params ?? {} };
        }
        if (body.message) {
            return { key: toMessageKey(body.message), params: body.params ?? {} };
        }
    }
    return { key: fallbackKey, params: {} };
};

export default apiResponseMessage;
